<script lang="ts">
	import Button from '../ui/Button.svelte';
	import knwoledgebase from '$lib/assets/sections/knowledgebase_section.png';
	export let knowledgeBasePage: any;
</script>

<!-- <section class="bg-black px-8 pb-48 pt-32 md:px-16">
	<div
		class="m-auto flex max-w-screen-2xl flex-col items-center justify-center gap-x-24 gap-y-24 md:flex-row"
	>
		<img
			src={knowledgeBasePage.public_image_url}
			alt="Decoration"
			class="h-64 w-64 shrink-0 rounded-full bg-white object-cover object-center"
		/>

		<div
			class="flex flex-col items-center justify-center gap-12 text-tertiary-400 md:basis-[600px] md:items-start"
		>
			<h2 class="text-3xl">Knowledgebase</h2>
			<p class="text-center md:text-left">
				Check out our custom Wiki with all the answers you are looking for. Explore our ever-growing
				F.A.Q. and use the „Get Help“ form to contact us directly. You will also find all info on
				workshops, certificates, manufacturers and wrapping tools, design templates and much more..
			</p>

			<a href="/knowledgebase">
				<Button outline size="lg">Show me more</Button>
			</a>
		</div>
	</div>
</section> -->

<section class="bg-black">
	<div
		class="mx-auto flex max-w-screen-2xl flex-col items-center justify-center gap-16 px-2 py-32 md:flex-row md:px-16 md:px-8 lg:gap-32"
	>
		<div class="shrink-0">
			<img
				src={knwoledgebase}
				alt=""
				class="h-72 w-72 rounded-full object-cover object-center lg:h-96 lg:w-96"
			/>
		</div>
		<div class="flex max-w-[600px] flex-col items-start justify-center gap-11 text-white">
			<h2 class="text-4xl">Knowledge Base</h2>
			<p>
				Check out our custom Wiki with all the answers you are looking for. Explore our ever-growing
				F.A.Q. and use the „Get Help“ form to contact us directly. You will also find all info on
				workshops, certificates, manufacturers and wrapping tools, design templates and much more..
			</p>

			<a href={knowledgeBasePage.path}>
				<Button size="lg">Show me more</Button>
			</a>
		</div>
	</div>
</section>
